/* ZIP availability check
   Reads the shared region from window.USDORegion (assets/usdo-region.js) and the
   per-state sellable quantity from the variant metafield custom.state_availability.
   Setting a ZIP here saves it for the whole session and updates the header bar.

   The theme replaces parts of the product section on every variant selection, so
   the page-level listeners live at module scope and re-attach to whatever roots
   are on the page, rather than being bound per root and leaking on each swap.

   Lead time: a product may override the default "2 to 4 business days" wording by
   setting the product metafield custom.lead_time. The snippet passes it through as
   data-lead-time. Absent means the default wording, so nothing changes for the
   rest of the catalog. */
(function () {
  function roots() { return document.querySelectorAll(".zipavail"); }

  function cartQtyFor(root) {
    var f = root.closest("form[action*='/cart/add']") || document.querySelector("form[action*='/cart/add']");
    var q = f && f.querySelector("[name='quantity']");
    var n = q ? parseInt(q.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function currentVariantId(root) {
    var f = root.closest("form[action*='/cart/add']") || document.querySelector("form[action*='/cart/add']");
    var sel = f && f.querySelector("[name='id']");
    if (sel && sel.value) return String(sel.value);
    var u = new URLSearchParams(location.search).get("variant");
    return u ? String(u) : String(root.dataset.defaultVariant || "");
  }

  function init(root) {
    var R = window.USDORegion;
    if (!R) return;
    if (root.getAttribute("data-zipavail-ready")) return;
    root.setAttribute("data-zipavail-ready", "1");

    var NAMES = R.STATE_NAMES;
    var OFFSHORE = R.OFFSHORE;

    var dataEl = root.querySelector(".zipavail-data");
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var leadTime = (root.dataset.leadTime || "").trim();

    var zipEl = root.querySelector(".zipavail__zip");
    var goEl = root.querySelector(".zipavail__go");
    var fbEl = root.querySelector(".zipavail__fallback");
    var stEl = root.querySelector(".zipavail__state");
    var resEl = root.querySelector(".zipavail__result");
    var txtEl = root.querySelector(".zipavail__text");
    if (!zipEl || !goEl || !stEl || !resEl) return;

    var opt = document.createElement("option");
    opt.value = ""; opt.textContent = "Choose your state…";
    stEl.appendChild(opt);
    Object.keys(NAMES).sort().forEach(function (s) {
      var o = document.createElement("option");
      o.value = s; o.textContent = NAMES[s]; stEl.appendChild(o);
    });

    function show(cls, msg) {
      resEl.hidden = false;
      resEl.className = "zipavail__result " + cls;
      txtEl.textContent = msg;
    }

    function evaluate(state) {
      if (OFFSHORE[state]) {
        show("is-partial", OFFSHORE[state] +
          " is quoted separately. Call us and we'll price the freight for you.");
        return;
      }
      var vid = currentVariantId(root);
      var avail = data[vid];
      if (!avail) { show("", "Select an option above and we'll check it."); return; }
      var want = cartQtyFor(root);
      var raw = parseInt(avail[state], 10);

      // -1 means the variant has no quantity limit: either inventory is not
      // tracked, or the product is set to keep selling when out of stock.
      if (raw === -1) {
        show("is-ok", leadTime
          ? "Ships to " + NAMES[state] + ". " + leadTime
          : "Available for " + NAMES[state] + ". Leaves the warehouse in 2 to 4 business days.");
        return;
      }

      var have = Math.max(0, isNaN(raw) ? 0 : raw);

      // Yes or no only. We never publish the quantity we are holding.
      if (have >= want) {
        show("is-ok", leadTime
          ? "Ships to " + NAMES[state] + ". " + leadTime
          : "In stock for " + NAMES[state] + ". Leaves the warehouse in 2 to 4 business days.");
      } else if (want > 1 && have > 0) {
        show("is-none", "We can't ship all " + want + " to " + NAMES[state] +
          " right now. Call us and we'll check lead times.");
      } else {
        show("is-none", "Not available for " + NAMES[state] + " right now. " +
          "Another finish may ship right away, or call us for a lead time.");
      }
    }

    // Saving here updates the header bar and every other page this session.
    function submitZip() {
      var r = R.set(zipEl.value);
      if (!r) {
        fbEl.hidden = false;
        show("", "We don't recognize that ZIP. Pick your state and we'll check it that way.");
        return;
      }
      fbEl.hidden = true;
    }

    function sync() {
      var r = R.get();
      if (!r) {
        resEl.hidden = true;
        zipEl.value = "";
        stEl.value = "";
        return;
      }
      if (r.zip) zipEl.value = r.zip;
      if (stEl.value !== r.state) stEl.value = r.state;
      fbEl.hidden = !!r.zip;
      evaluate(r.state);
    }
    root.zipavailSync = sync;

    goEl.addEventListener("click", submitZip);
    zipEl.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); submitZip(); }
    });
    stEl.addEventListener("change", function () { if (stEl.value) R.setState(stEl.value); });

    // Already know where they are? Answer immediately, no typing.
    sync();
  }

  function refreshAll() {
    var list = roots();
    for (var i = 0; i < list.length; i++) {
      init(list[i]);
      if (list[i].zipavailSync) list[i].zipavailSync();
    }
  }

  function deferred() { setTimeout(refreshAll, 0); setTimeout(refreshAll, 140); }

  document.addEventListener("usdo:region", refreshAll);
  document.addEventListener("variant:update", deferred);
  document.addEventListener("shopify:section:load", deferred);
  document.addEventListener("change", function (e) {
    if (e.target && (e.target.name === "id" || e.target.name === "quantity")) refreshAll();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAll);
  } else { refreshAll(); }
})();